import { ChannelIcon } from 'components/icons';

const statusConfig: Record<string, { label: string; className: string }> = {
    running:         { label: 'Mission en cours',          className: 'bg-leadrs-green-soft text-leadrs-green-focus' },
    on_market:       { label: "En attente d'un acheteur",  className: 'bg-leadrs-yellow-soft text-leadrs-yellow-focus' },
    waiting_payment: { label: 'En attente de paiement',    className: 'bg-leadrs-yellow-soft text-leadrs-yellow-focus' },
    done:            { label: 'Mission terminée',           className: 'bg-leadrs-bg text-leadrs-text-soft' },
};

const OfferCard = (props: {
    image: string;
    offerNumber: string;
    title: string;
    author: string;
    download?: string;
    price: string | number;
    weeklyQuantity?: string | number;
    extra?: string;
    status?: string;
    buttonDisabled?: boolean;
    isKYCVerified?: boolean;
    isValidated?: boolean;
    isArchived?: boolean;
    channels: any;
    onClick?: () => void;
}) => {
    const { title, author, image, status, weeklyQuantity, offerNumber, onClick, channels } = props;

    const statusInfo = statusConfig[status] ?? null;

    return (
        <div
            className="relative flex w-full cursor-pointer flex-col rounded-xl border border-leadrs-stroke bg-white p-4 transition-shadow hover:shadow-md"
            onClick={onClick}
        >
            {image ? (
                <img
                    src={image}
                    className="mb-3 h-[130px] w-full rounded-xl object-cover"
                    alt=""
                />
            ) : (
                <div className="mb-3 flex h-[130px] w-full items-center justify-center rounded-xl bg-leadrs-bg">
                    <div className="text-center">
                        <p className="font-geist text-sm font-bold text-leadrs-text">{title}</p>
                        <p className="font-geist text-xs text-leadrs-text-soft">{author}</p>
                    </div>
                </div>
            )}

            <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                    <div className="flex items-center gap-2">
                        <p className="font-geist text-sm font-bold text-leadrs-text truncate">{title}</p>
                        {offerNumber && (
                            <p className="flex-shrink-0 font-geist text-xs text-leadrs-text-soft">#{offerNumber}</p>
                        )}
                    </div>
                    <p className="font-geist text-xs text-leadrs-text-soft">{author}</p>
                </div>
            </div>

            {channels?.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1.5">
                    {channels.map((channel: string) => (
                        <div key={channel} className="text-leadrs-brand">
                            <ChannelIcon channel={channel} />
                        </div>
                    ))}
                </div>
            )}

            <div className="mt-3 flex items-center justify-between">
                <p className="font-geist text-sm font-semibold text-leadrs-text">
                    {weeklyQuantity} leads
                </p>
                {statusInfo && (
                    <span className={`rounded-full px-2.5 py-1 font-geist text-xs font-medium ${statusInfo.className}`}>
                        {statusInfo.label}
                    </span>
                )}
            </div>
        </div>
    );
};

export default OfferCard;
